import { confirmSignUp, resendSignUpCode } from "aws-amplify/auth";
import { VerificationSchema } from "@validators/auth";
import { authBus } from "../AuthEvents";

export const registerConfirmation = async ({ email, code }: VerificationSchema) => {
  try {
    // 1. V6 functional API - takes named parameters
    const { isSignUpComplete, nextStep } = await confirmSignUp({
      username: email,
      confirmationCode: code.trim(),
    });

    if (isSignUpComplete || nextStep.signUpStep === "DONE") {
      authBus.emitMessage("Registration confirmed! You can now login.", "success");
      authBus.emitTransition("login");
    }
  } catch (error: any) {
    let userMessage = "An error occurred. Please try again.";

    switch (error.name) {
      case "ExpiredCodeException":
        userMessage = "This code has expired. A new code has been sent to your email.";
        // 2. V6 replacement for resendConfirmationCode
        await resendSignUpCode({ username: email });
        break;

      case "CodeMismatchException":
        userMessage = "Incorrect code. Please try again.";
        break;

      case "NotAuthorizedException":
        // 3. Handle the "Already Confirmed" case specifically
        if (error.message.includes("Current status is CONFIRMED")) {
          authBus.emitMessage("Account already confirmed. Please login.", "error");
          authBus.emitTransition("login");
          return;
        }
        break;

      case "TooManyFailedAttemptsException":
        userMessage = "Too many failed attempts. Please wait 10 minutes.";
        break;

      case "LimitExceededException":
      case "TooManyRequestsException":
        userMessage = "Too many requests. Please wait a minute.";
        break;

      default:
        userMessage = error.message || userMessage;
        break;
    }

    authBus.emitMessage(userMessage, "error");
  }
};
